var map = {
	"./alert-circle.svg": [
		9359,
		9359
	],
	"./alert-triangle.svg": [
		49449,
		9449
	],
	"./arrow-back.svg": [
		18589,
		8589
	],
	"./arrow-narrow-left.svg": [
		89384,
		9384
	],
	"./arrow-narrow-right.svg": [
		29550,
		9550
	],
	"./arrows-maximize.svg": [
		74009,
		4009
	],
	"./arrows-minimize.svg": [
		70215,
		215
	],
	"./arrows-sort.svg": [
		22165,
		2165
	],
	"./barcode.svg": [
		41328,
		1328
	],
	"./basket.svg": [
		720,
		720
	],
	"./bell-ringing.svg": [
		10524,
		524
	],
	"./benefits.svg": [
		91762,
		1762
	],
	"./book.svg": [
		30190,
		190
	],
	"./brand-facebook.svg": [
		3431,
		3431
	],
	"./brand-freshful.svg": [
		50597,
		597
	],
	"./brand-messenger.svg": [
		1320,
		1320
	],
	"./brand-whatsapp.svg": [
		62041,
		2041
	],
	"./building.svg": [
		43346,
		3346
	],
	"./bulb.svg": [
		44960,
		4960
	],
	"./buy-more-cart.svg": [
		42587,
		2587
	],
	"./calendar-plus.svg": [
		3093,
		3093
	],
	"./calendar-time.svg": [
		39646,
		9646
	],
	"./card.svg": [
		24470,
		4470
	],
	"./cart-arrow.svg": [
		13632,
		3632
	],
	"./cart-plus.svg": [
		61136,
		1136
	],
	"./cart.svg": [
		17652,
		7652
	],
	"./cash.svg": [
		64108,
		4108
	],
	"./category.svg": [
		12259,
		2259
	],
	"./check.svg": [
		91940,
		1940
	],
	"./chef-hat.svg": [
		1943,
		1943
	],
	"./chevron-down.svg": [
		67754,
		7754
	],
	"./chevron-left.svg": [
		43173,
		3173
	],
	"./chevron-right.svg": [
		44509,
		4509
	],
	"./chevron-up.svg": [
		32060,
		2060
	],
	"./chevrons-down.svg": [
		91670,
		1670
	],
	"./clock.svg": [
		68073,
		8073
	],
	"./cooking.svg": [
		60798,
		798
	],
	"./courier.svg": [
		86114,
		6114
	],
	"./credit-card.svg": [
		23902,
		3902
	],
	"./discount.svg": [
		29686,
		9686
	],
	"./edit.svg": [
		19655,
		9655
	],
	"./enter.svg": [
		75380,
		5380
	],
	"./envelope.svg": [
		6304,
		6304
	],
	"./facebook.svg": [
		41338,
		1338
	],
	"./file-text.svg": [
		35246,
		5246
	],
	"./filter.svg": [
		4591,
		4591
	],
	"./flame.svg": [
		27147,
		7147
	],
	"./freshclub.svg": [
		62196,
		2196
	],
	"./gift.svg": [
		65454,
		5454
	],
	"./hamburger.svg": [
		8305,
		8305
	],
	"./heart.svg": [
		23728,
		3728
	],
	"./history.svg": [
		55964,
		5964
	],
	"./info-circle-2.svg": [
		38877,
		8877
	],
	"./info-circle.svg": [
		4594,
		4594
	],
	"./instagram.svg": [
		61051,
		1051
	],
	"./leaf.svg": [
		333,
		333
	],
	"./link.svg": [
		14590,
		4590
	],
	"./linkedin.svg": [
		13825,
		3825
	],
	"./list.svg": [
		86992,
		6992
	],
	"./logout.svg": [
		61904,
		1904
	],
	"./map-pin.svg": [
		48562,
		8562
	],
	"./menu-2.svg": [
		71875,
		1875
	],
	"./message-circle.svg": [
		6879,
		6879
	],
	"./messenger.svg": [
		11570,
		2392
	],
	"./minus.svg": [
		18611,
		8611
	],
	"./notes.svg": [
		72181,
		2181
	],
	"./plus.svg": [
		92839,
		2839
	],
	"./quote.svg": [
		90611,
		611
	],
	"./quotes.svg": [
		16142,
		6142
	],
	"./receipt-refund.svg": [
		20381,
		381
	],
	"./replace.svg": [
		84184,
		4184
	],
	"./save-me.svg": [
		92170,
		2170
	],
	"./search.svg": [
		35501,
		5501
	],
	"./sgr.svg": [
		40928,
		928
	],
	"./shopping-bag.svg": [
		16212,
		6212
	],
	"./shopping-cart-add.svg": [
		65494,
		5494
	],
	"./shopping-cart.svg": [
		89149,
		9149
	],
	"./slice.svg": [
		99209,
		9209
	],
	"./snowflake.svg": [
		86974,
		6974
	],
	"./star.svg": [
		74087,
		4087
	],
	"./storefront.svg": [
		17210,
		7210
	],
	"./ticket.svg": [
		7563,
		7563
	],
	"./tools-kitchen.svg": [
		16153,
		6153
	],
	"./trash.svg": [
		54985,
		4985
	],
	"./truck.svg": [
		93234,
		3234
	],
	"./user.svg": [
		73945,
		3945
	],
	"./x.svg": [
		70205,
		205
	],
	"./youtube.svg": [
		9428,
		9428
	],
	"./zoom-in.svg": [
		32597,
		2597
	],
	"./zoom-out.svg": [
		99355,
		9355
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 20549;
module.exports = webpackAsyncContext;